import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item', 'button', 'panel']

  toggle (event) {
    const index = this.buttonTargets.indexOf(event.currentTarget)
    const item = this.itemTargets[index]
    const panel = this.panelTargets[index]
    if (!item || !panel) return

    const expanded = event.currentTarget.getAttribute('aria-expanded') === 'true'
    if (!expanded) this.closeOtherItems(index)
    event.currentTarget.setAttribute('aria-expanded', String(!expanded))
    this.setItemState(item, panel, !expanded, index)
  }

  closeOtherItems (openIndex) {
    this.itemTargets.forEach((item, index) => {
      if (index === openIndex || !item.classList.contains('open')) return

      this.buttonTargets[index]?.setAttribute('aria-expanded', 'false')
      this.setItemState(item, this.panelTargets[index], false, index)
    })
  }

  setItemState (item, panel, open, index) {
    if (!panel) return

    item.classList.toggle('open', open)
    item.classList.toggle('mb-[20px]', open)
    item.classList.toggle('bg-ladot-green-soft', open)
    item.classList.toggle('rounded-[12px]', open)
    item.classList.toggle('shadow-[0_8px_16px_rgba(145,158,171,0.16)]', open)
    if (index > 0) {
      item.classList.toggle('border-t', !open)
      item.classList.toggle('border-ladot-border', !open)
    }

    if (open) {
      panel.hidden = false
      return
    }

    const hidePanel = () => {
      if (!item.classList.contains('open')) panel.hidden = true
    }
    panel.addEventListener('transitionend', (event) => {
      if (event.propertyName === 'grid-template-rows') hidePanel()
    }, { once: true })
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      hidePanel()
    } else {
      window.setTimeout(hidePanel, 350)
    }
  }
}
